import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SegovPage } from 'src/app/app.routes';
import { ResultadoPesquisaJornalOutputDto } from 'src/app/domain/DTOs/output/jornal/resultado-pesquisa-jornal.output.dto';
import { TransferirDadosParaEdicaoDoDiaParams } from 'src/app/domain/routeParamsModels/transferir-dados-para-edicao-do-dia.params';
import { ETipoVisualizacaoMateria } from 'src/app/domain/enums/tipo-visualizacao-materia.enum';
@Component({
  selector: 'app-card-dados-publicacao',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './card-dados-publicacao.component.html',
  styleUrl: './card-dados-publicacao.component.css'
})
export class CardDadosPublicacaoComponent implements AfterViewInit {
  readonly tipoVisualizacaoMateria = ETipoVisualizacaoMateria;
  /* eslint-disable @typescript-eslint/no-explicit-any*/
  @ViewChild('textoHighlight', {static: false}) textoHighlight: any;

  _dadosJornal?: ResultadoPesquisaJornalOutputDto;
  get dadosJornal() : ResultadoPesquisaJornalOutputDto | undefined {
    return this._dadosJornal;
  }
  @Input() set dadosJornal(value: ResultadoPesquisaJornalOutputDto) {
    this._dadosJornal = value;
    this.onObtemDados();
  }

  @Input() textoPesquisa = '';
  @Input() segundoTomDeFundo  = false;

  @Output() downloadIdOutput = new EventEmitter<ResultadoPesquisaJornalOutputDto>();

  constructor(
    private readonly router: Router,
    private readonly renderer: Renderer2,
  ){
  }

  ngAfterViewInit(): void {
    this.onObtemDados();
  }

  public MapeamentoDadosPublicacaoJornal(){
    const jornal : TransferirDadosParaEdicaoDoDiaParams = {
        dataPublicacaoSelecionada: this.dadosJornal?.dataPublicacao,
        idCadernoEdicaoSelecionado: this.dadosJornal?.tipoVisualizacaoMateria === ETipoVisualizacaoMateria.HTML ? this.dadosJornal?.cadernoEdicaoId : this.dadosJornal?.idJornal,
        edicaoId: this.dadosJornal?.edicaoId,
        publicacaoId: this.dadosJornal?.publicacaoId,
        paginaSelecionada: this.dadosJornal?.pagina,
        textoPesquisa: encodeURIComponent(this.textoPesquisa??'')
    }
    this.gotoPublicacaoJornal(jornal);
  }

  public obtemDadosJornal(){
    this.downloadIdOutput.emit(this.dadosJornal);
  }

  private gotoPublicacaoJornal(parametros: TransferirDadosParaEdicaoDoDiaParams){
    const link =  this.router.serializeUrl(this.router.createUrlTree([SegovPage.EdicaoDoDia], {queryParams: {dados: JSON.stringify(parametros)}}))
    window.open(link, '_blank')
  }

  private onObtemDados(){
    const texto = this.removeAcentos(this.dadosJornal?.textoResultado?.toUpperCase() ?? '');
    const textoPesquisa = this.removeAcentos(this.textoPesquisa.toUpperCase());
    if(texto?.includes(textoPesquisa)){
      this.renderer.setProperty(
        this.textoHighlight?.nativeElement,
        'innerHTML',
        this.marcarTextoPesquisado(textoPesquisa)
      )
    }
  }

  private marcarTextoPesquisado(value: string) {
    const re = new RegExp(`(${this.criarPadraoAcentoIgnorado(value.trim())})`, 'gi');
    return this.dadosJornal?.textoResultado?.normalize('NFD').replace(re, (match) => `<strong class="highlight">${match.normalize('NFC')}</strong>`);
  }

  private removeAcentos(texto: string) {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  private criarPadraoAcentoIgnorado(value: string) {
    return Array.from(value)
      .map(caractere => `${caractere.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}[\\u0300-\\u036f]*`)
      .join('');
  }
}